
export default {
  init(fromid, output_id) {
    $('#' + fromid).on('submit', function (e) { 
      e.preventDefault();
      console.log($(this).attr('id'));
      $.ajax({
        url: $(this).attr('action'),
        data: new FormData($(this)[0]),
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
        type: 'json',
        beforeSend: function () {
          $('.wait').show();                  
        },
        complete: function () {
          $('.wait').hide();                     
        },
        success: function (data) {
          $('#' + output_id).html(''); 
          $('#' + output_id)
            .html(data.html)
            .fadeIn();
          setTimeout(function () { }, 3000);
        },
        error: function () {
          $('#' + output_id)
            .append('<div><p> Error! </p> </div>')
            .fadeIn();
        },
      });
    });

    // init from propoty
    $('#initfromProperty').on('submit', function (e) { 
      e.preventDefault();
      //console.log($(this).attr('id'));
      $.ajax({
        url: '/session.php',
        data: new FormData($(this)[0]),
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
        type: 'json',
        success: function (data) {
          console.log(data);
          location.href = '/immobilien-ergebnisse';
        },
        error: function () {
          console.log('error');
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/util/ajax.js